import { Action } from "redux";
import { Task } from "redux-saga";
import { ActionPattern, cancel, fork, take } from "redux-saga/effects";

type KeyReducerAction = Action & { payload: { keyReducer: string } };

export function takeLatestByKeyReducer<A extends KeyReducerAction>(
	pattern: ActionPattern<A>,
	worker: (action: A) => unknown,
) {
	return fork(function* watchLatestByKeyReducer() {
		const tasksByKeyReducer: Record<string, Task> = {};

		while (true) {
			const action: A = yield take(pattern);
			const runningTask = tasksByKeyReducer[action.payload.keyReducer];

			if (runningTask) yield cancel(runningTask);

			const task: Task = yield fork(worker, action);
			tasksByKeyReducer[action.payload.keyReducer] = task;
		}
	});
}
